export default __webpack_public_path__ + "static/media/Group1497TataNeu@2x.c166b43d.png";